var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.onVisibilityChange),expression:"onVisibilityChange"}],staticClass:"content-scrollload"},[_c('i',{staticClass:"content-scrollload-icon fa fa-spinner fa-spin"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }